'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { FC, useLayoutEffect, useRef } from 'react';
import { useHashScrollOnLoad } from '@/hooks/useHashScrollOnLoad';
import { gsap, ScrollSmoother } from '@/lib/gsap';
import { BasicProps } from '@/types/common';
import css from './style.module.scss';
const ScrollSmoothContainer: FC<BasicProps> = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
  const smootherRef = useRef(null);
  useHashScrollOnLoad(pathname);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
      const ctx = gsap.context(() => {
        const matchMedia = gsap.matchMedia();
        matchMedia.add({
          isDesktop: "(min-width: 992px)",
          isMobile: "(max-width: 991px)"
        }, context => {
          const {
            isMobile
          } = context.conditions as gsap.Conditions;
          if (isMobile) {
            return;
          }
          const wrapper = wrapperRef.current;
          const content = contentRef.current;
          if (wrapper && content) {
            smootherRef.current = (ScrollSmoother as any).create({
              wrapper,
              content,
              smooth: 2,
              smoothTouch: 0.1,
              effects: false,
              wholePixels: true
            });
          }
        });
      }, wrapperRef);
      return () => ctx.revert();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (smootherRef.current) {
        if (!window.location.hash) {
          smootherRef.current.scrollTop(0);
        }
        ScrollSmoother.refresh();
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== pathname) {
    t4 = [pathname];
    $[3] = pathname;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useLayoutEffect(t3, t4);
  let t5;
  if ($[5] !== children) {
    t5 = <div ref={wrapperRef}><div ref={contentRef} className={css.content}>{children}</div></div>;
    $[5] = children;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default ScrollSmoothContainer;